import type {
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import {
  useQuery,
} from '@tanstack/react-query'
import type { Moment } from 'moment'

import * as TripKeys from '../reactQueryKeys/trips'

import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { getFlightSchedule } from 'tripPlanner/api/misc/flightStatus'
import type { GetFlightScheduleError } from 'tripPlanner/api/types'
import * as Mappers from 'tripPlanner/mappers'
import type { FlightSchedule } from 'tripPlanner/types/common'
import { sortFlightSchedules } from 'tripPlanner/utils/flights'

interface Args {
  flightCode: string
  departureDate: Moment
}

export const useGetFlightSchedules = (
  { departureDate, flightCode }: Args,
  options?: UseQueryOptions<
    Awaited<ReturnType<typeof getFlightSchedule>>,
    GetFlightScheduleError,
    Array<FlightSchedule>
  >,
): UseQueryResult<Array<FlightSchedule>, GetFlightScheduleError> => {
  return useQuery({
    queryKey: TripKeys.flightSchedule(
      flightCode,
      departureDate.format(ISO_DATE_FORMAT),
    ),
    queryFn: () => getFlightSchedule({ flightCode, departureDate }),
    select: (flights) => {
      const mappedFlights = flights.map(Mappers.flightSchedule)
      return sortFlightSchedules(mappedFlights)
    },
    ...options,
  })
}
